import Skirting from "../Skirting";

export default abstract class Standing extends Skirting {}
